import { Component, OnInit } from '@angular/core';
import { TechfinanceService } from 'src/app/services/techfinance.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {
  private searchSubject: Subject<string> = new Subject<string>();
  private destroy$ = new Subject<void>();

  clientsData!: any[];
  hasClients: boolean = false;
  isLoading: boolean = true;
  search!: string;
  pagination!: number;
  selectedStudy!: string | number;
  

  //PAGINAS

  currentPage: number = 1;
  totalPages!: number;
  pagesArray: number[] = [];

  constructor(
    private techfinanceService: TechfinanceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getUserClients();

    this.searchSubject
      .pipe(debounceTime(400), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.getUserClients(1);
      });
  }

  onSearchChange(): void {
    this.searchSubject.next(this.search);
  }
  

  getUserClients(page: number = 1) {
    this.isLoading = true

    const pageSize = 5;
    this.currentPage = page;

    this.techfinanceService
      .getClients(page - 1, pageSize, this.search || '')
      .subscribe((res) => {
        this.clientsData = res.results;
        this.hasClients = this.clientsData.length > 0;
        this.totalPages = Math.ceil(res.count / pageSize);
        this.updatePagesArray();
        this.isLoading = false
      });
  }

  updatePagesArray() {
    const maxVisiblePages = 5;
    let startPage = Math.max(
      this.currentPage - Math.floor(maxVisiblePages / 2),
      1
    );
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > this.totalPages) {
      endPage = this.totalPages;
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }

    this.pagesArray = [];
    for (let i = startPage; i <= endPage; i++) {
      this.pagesArray.push(i);
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.getUserClients(page);
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.getUserClients(this.currentPage - 1);
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.getUserClients(this.currentPage + 1);
    }
  }

  goToClientStudies(clientId: string) {
    this.router.navigate(['inicio/clientes', clientId, 'estudos']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}
